import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HOME',
    component: () => import('../components/HomeView.vue')
  },
  {
    path: '/login',
    name: 'LOGIN',
    component: () => import('../components/LoginView.vue')
  },
  {
    path: '/movie:id',
    name: 'MOVIE',
    component: () => import('../components/MovieView.vue'),
  },
  {
    path: '/roomplan:obj',
    name: 'ROOMPLAN',
    component: () => import('../components/RoomPlanView.vue'),
  },
  {
    path: '/sweetshop:obj',
    name: 'SWEETSHOP',
    component: () => import('../components/SweetShopView.vue'),
  },
  {
    path: '/redirect:obj',
    name: 'REDIRECT',
    component: () => import('../components/RedirectView.vue'),
  },
  /*{
    path: '/redirectcart',
    name: 'REDIRECTCART',
    component: () => import('../components/RedirectCartView.vue'),
  },*/

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router